module.exports = __webpack_public_path__ + "img/house_reconstruction.8fb2e667.gif";